import React from 'react';

import Page from 'components/Page';
import ContentSection from 'components/ContentSection';
import CenterContent from 'components/CenterContent';
import SectionIntro from 'components/SectionIntro';
import ServiceInformation from 'components/ServiceInformation';
import CollaborationButton from 'components/CollaborationButton';
import HowWeWork from 'components/HowWeWork';

// import themes from 'themes';

// const IntroBgSvg = encodeURIComponent(
//   `<svg width="30" height="30" xmlns='http://www.w3.org/2000/svg'><circle cx="15" cy="15" r="1" fill="${themes.dark.colors.silverDarken75}" /></svg>`
// );
// const IntroBgUrl = `url("data:image/svg+xml;utf8,${IntroBgSvg}")`;

const metaTags = {
  title: 'webkid - services',
  author: 'Webkid',
  twitterUsername: '@wbkd',
  description: 'webkid creates visualizations, tools and interactive maps',
  siteUrl: 'https://webkid.io/services/',
  robots: 'index,follow',
};

const Services = () => {
  return (
    <Page metaTags={metaTags} showBanner>
      <ContentSection centered>
        <SectionIntro title="How We Work" />
        <HowWeWork />
      </ContentSection>
      <ContentSection bg="violetLighten5">
        <CenterContent>
          <SectionIntro
            title="Our Services"
            text="We develop innovative visualizations, customized tools and interactive maps that make your data easier to understand."
          />
        </CenterContent>
        <ServiceInformation
          icon="datavis"
          title="Data Visualizations"
          text="Do you want your data to look different? With customized data visualizations we make it possible to present your data exactly the way you prefer it. Each of our visualizations is state of the art and programmed individually for your needs. During the implementation pixel-perfect details are just as important to us as the performance on mobile devices."
          skills={[
            'Find the best way to present your data',
            'Enrich a journalistic article with a visualization',
            'Pick the most suitable technologies',
            'Implement perfectly functioning visualizations',
          ]}
          projects={[
            {
              client: 'Zeit Online',
              label: 'What the Bundestag Is Talking About',
              href: '/projects/zeit-online-bundestag-speeches',
            },
            {
              client: 'DataDesign Studio',
              label: 'Sustainable Development Goals',
              href: '/projects/datastudio-sustainable-development-goals',
            },
          ]}
        />

        <ServiceInformation
          highlightBg
          icon="maps"
          title="Interactive Maps"
          text="Does your dataset contain georeferenced records? Our map services help you to create detailed interactive maps from your data. Drawing from our experience with numerous mapping projects, we create all kinds of web-based interactive maps, such as choropleth, bubble, 3D or animated rental maps. We also support you in working with shapefiles, converting projections or simplifying geodata."
          skills={[
            'Develop fully interactive web maps',
            'Map your geodata with custom filters and views',
            'Process geodata',
            'Create vector and raster tiles',
          ]}
          projects={[
            {
              client: 'Zeit Online',
              label: 'The New Colors of Europe',
              href: '/projects/zeit-online-new-colors-of-europe',
            },
            {
              client: 'Berliner Morgenpost',
              label: 'How Old Is Berlin',
              href: '/projects/berliner-morgenpost-how-old-is-berlin',
            },
            {
              client: 'Berliner Morgenpost',
              label: 'Berlin Marathon',
              href: '/projects/berliner-morgenpost-berlin-marathon',
            },
          ]}
        />

        <ServiceInformation
          icon="tools"
          title="Custom Tools"
          text="Do you have special requirements? We develop individual software solutions based on your data. This could be dashboards, data analysis applications, data input tools or a customized JavaScript library – whatever you want to develop, we try to make it possible."
          skills={[
            'Develop a dashboard with different widgets',
            'Create a special tool to review your data',
            'Implement a newsgame with drag & drop functionality',
          ]}
          projects={[
            {
              client: 'Open Source',
              label: 'react-flow',
              href: 'https://github.com/wbkd/react-flow',
            },
            {
              client: 'Open Source',
              label: 'Smart Word Counter',
              href: 'https://wordcounter.webkid.io/',
            },
            {
              client: 'OECD',
              label: 'Simple Charts Library',
              href: '/blog/open-source-charting-tool',
            },
            {
              client: 'Berliner Morgenpost',
              label: 'Infographics Portfolio',
              href: 'https://www.morgenpost.de/infografik/#/',
            },
          ]}
        />

        <ServiceInformation
          highlightBg
          icon="dataprocessing"
          title="Data Processing"
          text="Do you need help with the preparation or collection of data? Almost all of our projects require us to transform, compress, convert or process data in some way. For these purposes we develop scrapers, APIs, data input tools and other special systems to help you get your data in shape."
          skills={[
            'Setup databases and APIs',
            'Extract data from websites',
            'Analyze, transform and merge datasets',
            'Process large data files',
          ]}
          projects={[
            {
              client: 'Zeit Online',
              label: 'The New Colors of Europe',
              href: '/projects/zeit-online-new-colors-of-europe',
            },
            {
              client: 'Berliner Morgenpost',
              label: 'Berlin Marathon',
              href: '/projects/berliner-morgenpost-berlin-marathon',
            },
            {
              client: 'Open Source',
              label: '(Geo) DataMerger',
              href: 'https://funkeinteraktiv.github.io/geo-data-merger/',
            },
            {
              client: 'Berliner Morgenpost',
              label: 'Berlin Public Transport Analysis',
              href: '/blog/visualization-of-data-along-public-transportation-lines-in-berlin/',
            },
          ]}
        />
        <CollaborationButton mt={[6, 7]} />
      </ContentSection>
    </Page>
  );
};

export default Services;
